<template>
        <grid class="g-m c-m">
            <row class="height60"  :reverse="!1" middle="xs" center="xs">
                <column :xs="3">
                    <i class="far fa-file-chart-line fa-3x"></i>
                </column>
                <column :xs="7" class="align-left">
                    <button class="dock-pull-button" @click="$router.push({name:'new_report'})">{{$t('reports.add.main_label').toLowerCase()}}</button>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="dpli-h height70" :reverse="!1" middle="xs" start="xs" v-for="item in reports" :key="item.id">
                <column :xs="7">

                    <div class="dock-pull-list-header">
                        {{item.name}}
                    </div>
                    <div class="dock-pull-list-desc">
<!--                        {{item.type}}-->
                    </div>
                </column>
                <column :xs="5" :style="{'text-align': 'right'}">
<!--                    <i class="far fa-cloud-download fa-2x" @click="getLastReport(item.type)"></i>&nbsp;<i class="far fa-edit fa-2x" @click="$router.push({name:'edit_report', params: {id: item.id}})"></i>-->
                    <i class="far fa-cloud-download fa-2x"></i>&nbsp;<i class="far fa-edit fa-2x" @click="$router.push({name:'edit_report', params: {id: item.id}})"></i>
                </column>
            </row>
        </grid>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SettingsReports',
  computed: {
    ...mapGetters({
      reports: 'getReports'
    })
  },
  methods: {
    ...mapActions(['getObjectsReports', 'getLastReport'])
  },
  created () {
    this.getObjectsReports(false)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/SettingsReports.vue